import axios from "@/axios.js";
import Outcomes from "./outcomes_service";

export default {
  getAllOutcomes({ commit }, item) {
    return new Promise((resolve, reject) => {
      Outcomes.getAllOutcomes(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchOutcomes(context, outcomeId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/outcomes/outcomes/${outcomeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeOutcome(context, outcomeId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/outcomes/outcomes/${outcomeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingOutcomeLists(context, outcome_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/outcomes/outcomes/get_existing_outcome_lists/${outcome_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingOutcomeLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/outcomes/outcomes/search_existing_outcome_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateOutcomes({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/outcomes/outcomes/update_outcome", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addOutcomes({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/outcomes/outcomes/add_outcomes", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeOutcomes({ commit }, outcomeId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/outcomes/outcomes/${outcomeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllActionTypesForOutcomes(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/outcomes/outcomes/get_all_action_types`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllOutcomesByActionype({ commit }, action_type_id) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .get(`/api/outcomes/outcomes/get_all_outcomes_by_action_type/${action_type_id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
